import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimCheckbox, ClaimTextField } from '../fields';

export const Box12_PatientSignature: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">
        {"12. PATIENT'S OR AUTHORIZED PERSON'S SIGNATURE"}
      </Typography>
      <Box display="flex" gap={1} alignItems="center" justifyContent="space-between">
        <Controller
          name="patientSignature.signed"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimCheckbox
              field={field}
              fieldState={fieldState}
              label="SIGNATURE ON FILE"
            />
          )}
        />
        <Box>
          <Controller
            name="patientSignature.date"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                type="date"
                size="small"
                label="Date"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Box>
      </Box>
    </>
  );
};